module.exports = __webpack_public_path__ + "img/b6-2.ec5b4f2.png";